export const INVOICE_STATUS = {
  CREATED: 'CREATED',
  PROCESSING: 'PROCESSING',
  PENDINGDOCUMENTSREVIEW: 'PENDINGDOCUMENTSREVIEW',
  REJECTED: 'REJECTED',
  REJECTEDPREOFFEREVALUATION: 'REJECTEDPREOFFEREVALUATION',
  PENDINGRATIFICATION: 'PENDINGRATIFICATION',
  REJECTEDRATIFICATION: 'REJECTEDRATIFICATION',
  REJECTEDDOCUMENTS: 'REJECTEDDOCUMENTS',
  PENDINGTRANSFER: 'PENDINGTRANSFER',
  REJECTEDTRANSFER: 'REJECTEDTRANSFER',
  TRANSFERED: 'TRANSFERED',
  OFFERED: 'OFFERED',
  DEBT: 'DEBT',
  FINISHED: 'FINISHED',
  SURPLUSWITHDRAWN: 'SURPLUSWITHDRAWN',
  BADDEBT: 'BADDEBT',
  LOANEDOTHER: 'LOANEDOTHER',
  RECEDED: 'RECEDED',
  EXPIRED: 'EXPIRED',
  PENDINGDOCUMENTSEXPIRED: 'PENDINGDOCUMENTSEXPIRED',
  INTERNALFINISHED: 'INTERNALFINISHED',
  PARTIALCOLLECTION: 'PARTIALCOLLECTION',
  PROROGUED: 'PROROGUED',
};

export const FINISHED_STATUS = [INVOICE_STATUS.FINISHED, INVOICE_STATUS.SURPLUSWITHDRAWN];
export const ACTIVE_CESSION_STATUSES = [
  INVOICE_STATUS.PROCESSING,
  INVOICE_STATUS.PENDINGDOCUMENTSREVIEW,
  INVOICE_STATUS.PENDINGRATIFICATION,
  INVOICE_STATUS.PENDINGTRANSFER,
  INVOICE_STATUS.TRANSFERED,
  INVOICE_STATUS.DEBT,
  INVOICE_STATUS.PROROGUED,
  INVOICE_STATUS.PARTIALCOLLECTION,
];
export const EXPOSED_STATUS = [
  INVOICE_STATUS.TRANSFERED,
  INVOICE_STATUS.DEBT,
  INVOICE_STATUS.PARTIALCOLLECTION,
  INVOICE_STATUS.PROROGUED,
];
export const DEBT_STATUS = [INVOICE_STATUS.DEBT, INVOICE_STATUS.PARTIALCOLLECTION];
export const REJECTED_STATUS = [
  INVOICE_STATUS.REJECTED,
  INVOICE_STATUS.REJECTEDRATIFICATION,
  INVOICE_STATUS.REJECTEDTRANSFER,
  INVOICE_STATUS.REJECTEDPREOFFEREVALUATION,
  INVOICE_STATUS.PENDINGDOCUMENTSEXPIRED,
  INVOICE_STATUS.REJECTEDDOCUMENTS,
];
export const EXPIRED_STATUS = [INVOICE_STATUS.EXPIRED];

export const CREDIT_NOTE_STATUSES = ['HAS_CREDIT_NOTE', 'PARTIAL_CREDIT_NOTE'];

export const INVOICE_STATUS_TO_GRAPHQL_FILTER = {
  PROCESSING: 'Processing',
  PENDINGDOCUMENTSREVIEW: 'PendingDocumentsReview',
  PENDINGRATIFICATION: 'PendingRatification',
  PENDINGTRANSFER: 'PendingTransfer',
  FINISHED: 'Finished',
  SURPLUSWITHDRAWN: 'SurplusWithdrawn',
  TRANSFERED: 'Transfered',
  DEBT: 'Debt',
  REJECTED: 'Rejected',
  REJECTEDRATIFICATION: 'RejectedRatification',
  REJECTEDTRANSFERED: 'RejectedTransfer',
  REJECTEDTRANSFER: 'RejectedTransfer',
  REJECTEDPREOFFEREVALUATION: 'RejectedPreofferEvaluation',
  PENDINGDOCUMENTSEXPIRED: 'PendingDocumentsExpired',
  REJECTEDDOCUMENTS: 'RejectedDocuments',
  EXPIRED: 'Expired',
  PARTIALCOLLECTION: 'PartialCollection',
  PROROGUED: 'Prorogued',
};

export const invoiceStatusesToGraphqlFilter = (statusCodes) => (
  statusCodes.map((code) => INVOICE_STATUS_TO_GRAPHQL_FILTER[code])
);

export const HISTORIC_INVOICES_STATUS_FILTER = invoiceStatusesToGraphqlFilter([
  ...FINISHED_STATUS,
  ...REJECTED_STATUS,
  ...EXPIRED_STATUS,
]);
